export default __webpack_public_path__ + "static/media/widget_watchbox_vpmes5f_buy.0bd3f103.mp3";